import React, { useState, useEffect } from "react";
import { Icon, Image, Divider, Header } from 'semantic-ui-react'
import image1 from "../../../assets/locations/niger-delta.jpg"
const Point26 = () => {
    return (
    <React.Fragment>
      <p>
      Језерски нивои и палеоеколошки налази из Африке, Арабије и јужне Азије за последњих 9000 година указују на то да се северни монсуни појачавају и полако померају ка полу. На јужној страни Сахаре вегетациони појасеви су се померили на север за 4-6о географске ширине. Обрнуто, монсун над јужном Африком је некад био слабији него данас. Прорачуни засновани на новој палеогеографској мапи указали су да се површински албедо умањио за 0,10-0,14 у зони између 16-24о северне ширине, а да су се укупне годишње падавине увећале за 150-320 mm северно од делте Нигера (20-24о15' N). Огледи с моделима опште атмосферске циркулације сугеришу да се овај асиметрични образац аномалија у јачини тропских монсуна може објаснити променом орбиталне геометрије Земље за 9000 година. Резултати нумеричког експеримента у коме је албедо изнад Африке и Арабијског полуострва (15-30о N) снижен за 0,04-0,06 како би се симулирала промена површинског албеда услед ширења вегетације у последњих 9000 година указују да промене површинског албеда изазивају значајан позитивни повратни ефекат који појачава непосредне климатске последице Миланковићевих циклуса у тропима. 
      </p>
      <Divider horizontal>
        <Header as="h4">
        <Icon name='image' />
        Фотографијa
        </Header>      
      </Divider>
      <Image src={image1} alt="DELTA NIGERA, MALI" fluid />
      

    </React.Fragment>
    )
  }

  export default Point26;

